export const CheckboxActiveIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="0.5" width="19" height="19" rx="5.5" fill="#E3F2FB" />
      <rect x="1" y="0.5" width="19" height="19" rx="5.5" stroke="#2378C8" />
      <path
        d="M15.1663 6.5L8.74967 12.9167L5.83301 10"
        stroke="#2378C8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
